import { render, staticRenderFns } from "./RecoMobiles.vue?vue&type=template&id=bed3fa98&scoped=true"
import script from "./RecoMobiles.vue?vue&type=script&lang=js"
export * from "./RecoMobiles.vue?vue&type=script&lang=js"
import style0 from "./RecoMobiles.vue?vue&type=style&index=0&id=bed3fa98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3fa98",
  null
  
)

export default component.exports